<div class="bigger-container">
  <div class="left-section">
    <p [ngClass]="{ selected: step === 0 }" (click)="changeTab(0)">
      Informazioni Richiesta
    </p>
    <p [ngClass]="{ selected: step === 1 }" (click)="changeTab(1)">
      Dettagli Richiesta
    </p>
    <p
      *ngIf="!isPartner"
      [ngClass]="{ selected: step === 2 }"
      (click)="changeTab(2)"
    >
      Stato Richiesta
    </p>
    <p [ngClass]="{ selected: step === 3 }" (click)="changeTab(3)">Registro</p>
    <p [ngClass]="{ selected: step === 4 }" (click)="changeTab(4)">
      Messaggi Richiesta
    </p>
    <p
      *ngIf="!isPartner"
      [ngClass]="{ selected: step === 5 }"
      (click)="changeTab(5)"
    >
      Cronologia operazioni
    </p>
    <p
      *ngIf="!isPartner"
      [ngClass]="{ selected: step === 6 }"
      (click)="changeTab(6)"
    >
      Feedback cliente
    </p>
  </div>

  <div class="right-section" *ngIf="request">
    <div class="back-button" (click)="goBack()">
      <i class="material-icons">arrow_back</i>
      <p>Torna alla lista</p>
    </div>
    <div class="smaller-container">
      <p class="smaller-text">
        {{ isNew ? "Crea" : "Modifica" }} Richiesta
        {{ isNew && request ? "" : "n. " + request.id }}
      </p>
      <div class="smaller-bar"></div>
    </div>
    <p
      class="my-button"
      *ngIf="updateRequired"
      (click)="isNew ? createRequest() : updateRequest(true)"
    >
      Salva
    </p>
    <!-- Section containing the script aimed to help the Family Tutor -->
    <div>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title><b>Script</b></mat-panel-title>
        </mat-expansion-panel-header>
        <div [innerHTML]="script"></div>
      </mat-expansion-panel>
    </div>
    <div class="mt-2">
      <mat-expansion-panel
        *ngIf="request.requestPersonalInfo.customer === 'B2B'"
      >
        <mat-expansion-panel-header>
          <mat-panel-title
            ><b>Referral program</b>
            @if(hasReferral && isActiveReferral){
            <span class="ms-2"
              ><i class="bi bi-check-circle-fill text-success"></i
            ></span>
            } @else if(hasReferral && !isActiveReferral){
            <span class="ms-2"
              ><i class="bi bi-exclamation-triangle-fill text-warning"></i
            ></span>
            } @else {
            <span class="ms-2"
              ><i class="bi bi-x-circle-fill text-danger"></i
            ></span>
            }
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <app-ref-code-panel
            [RequestEmail]="request.requestPersonalInfo.parentEmail"
            [RequestID]="request.id"
            (hasReferrral)="updateReferralIcon($event)"
            (isActiveReferral)="updateActiveStatus($event)"
          ></app-ref-code-panel>
        </div>
      </mat-expansion-panel>
    </div>

    <div class="mt-3" *ngIf="request">
      <!-- Request Operational Info -->
      <app-request-personal-info
        *ngIf="step === 0"
        [requestID]="request.id"
        [inputData]="request.requestPersonalInfo"
        [requestCategory]="request.requestPersonalInfo.requestCategory"
        (dataUpdated)="updateRequestPersonalInfo($event)"
        (addressUpdated)="updateCoordinates($event)"
      ></app-request-personal-info>
      <!-- Request Detail for Babysitters -->
      <app-request-babysitter-detail-form
        *ngIf="
          step === 1 &&
          request.requestPersonalInfo.requestCategory === 'BABYSITTER'
        "
        [requestID]="request.id"
        [inputData]="request.requestDetail"
        [provincia]="request.requestPersonalInfo.provincia"
        [reqService]="reqService"
        (dataUpdated)="updateRequestDetailInfo($event)"
      ></app-request-babysitter-detail-form>
      <!-- Request Detail for Petsitters -->
      <app-request-petsitter-detail-form
        *ngIf="
          step === 1 &&
          request.requestPersonalInfo.requestCategory === 'PETSITTER'
        "
        [requestID]="request.id"
        [inputData]="petsitterDetail"
        [provincia]="request.requestPersonalInfo.provincia"
        [reqService]="reqService"
        (dataUpdated)="updatePetsitterRequestDetailInfo($event)"
      ></app-request-petsitter-detail-form>
      <!-- Request Detail for Nurse -->
      <app-request-nurse-detail-form
        *ngIf="
          step === 1 && request.requestPersonalInfo.requestCategory === 'NURSE'
        "
        [requestID]="request.id"
        [inputData]="nurseDetail"
        [provincia]="request.requestPersonalInfo.provincia"
        [reqService]="reqService"
        (dataUpdated)="updateNurseRequestDetailInfo($event)"
      ></app-request-nurse-detail-form>
      <!-- Request Detail for Colf -->
      <app-request-colf-detail-form
        *ngIf="
          step === 1 && request.requestPersonalInfo.requestCategory === 'COLF'
        "
        [requestID]="request.id"
        [inputData]="colfDetail"
        [provincia]="request.requestPersonalInfo.provincia"
        [reqService]="reqService"
        (dataUpdated)="updateColfRequestDetailInfo($event)"
      ></app-request-colf-detail-form>
      <!-- Request Detail for Coach -->
      <app-request-coach-detail
        *ngIf="
          step === 1 && request.requestPersonalInfo.requestCategory === 'COACH'
        "
        [requestID]="request.id"
        [inputData]="coachDetail"
        [provincia]="request.requestPersonalInfo.provincia"
        [reqService]="reqService"
        (dataUpdated)="updateCoachRequestDetailInfo($event)"
      ></app-request-coach-detail>
      <!-- Request Detail for Psychologist -->
      <app-request-psychologist-detail
        *ngIf="
          step === 1 &&
          request.requestPersonalInfo.requestCategory === 'PSYCHOLOGIST'
        "
        [requestID]="request.id"
        [inputData]="psychologistDetail"
        [provincia]="request.requestPersonalInfo.provincia"
        [reqService]="reqService"
        (dataUpdated)="updatePsychologistRequestDetailInfo($event)"
      ></app-request-psychologist-detail>
      <!-- Psychologist Booking (Calendly) -->
      <app-psychologist-booking
        *ngIf="
          step === 1 &&
          request.requestPersonalInfo.requestCategory === 'PSYCHOLOGIST' &&
          psychologistDetail
        "
        class="mt-4 d-block"
        [request]="request"
        [psychologistDetail]="psychologistDetail"
        [assignedPsychologistId]="assignedPsychologist"
      ></app-psychologist-booking>
      <!-- Request Detail for Nutritionist -->
      <app-request-nutritionist-detail
        *ngIf="
          step === 1 &&
          request.requestPersonalInfo.requestCategory === 'NUTRITIONIST'
        "
        [requestID]="request.id"
        [inputData]="nutritionistDetail"
        (dataUpdated)="updateNutritionistRequestDetailInfo($event)"
        [provincia]="request.requestPersonalInfo.provincia"
        [reqService]="reqService"
      ></app-request-nutritionist-detail>
      <!-- Request Detail for Video Consultation -->
      <app-request-doctor-detail
        *ngIf="step === 1 && request.requestPersonalInfo.requestCategory === 'VIDEO_CONSULTATION'"
        [requestID]="request.id"
        [inputData]="videoConsultationDetail"
        (dataUpdated)="updateVideoConsultationRequestDetailInfo($event)"
        [provincia]="request.requestPersonalInfo.provincia"
        [reqService]="reqService"
      ></app-request-doctor-detail>
      <!-- Request Detail for In Person -->
      <app-request-doctor-detail
        *ngIf="step === 1 && request.requestPersonalInfo.requestCategory === 'IN_PERSON'"
        [requestID]="request.id"
        [inputData]="inPersonDetail"
        (dataUpdated)="updateInPersonRequestDetailInfo($event)"
        [provincia]="request.requestPersonalInfo.provincia"
        [reqService]="reqService"
      ></app-request-doctor-detail>
      <!-- Request Detail for Longevity: nessun dettaglio specifico -->
      <p
        class="mt-3"
        *ngIf="
          step === 1 &&
          request.requestPersonalInfo.requestCategory === 'LONGEVITY'
        "
      >
        <i class="bi bi-info-circle me-2"></i>Per la Longevity non ci sono
        dettagli da compilare: la persona risponde al questionario dalla sua
        area personale.
      </p>
      <!-- Request Detail for Supporto caregiver: nessun dettaglio specifico -->
      <p
        class="mt-3"
        *ngIf="
          step === 1 &&
          request.requestPersonalInfo.requestCategory === 'CAREGIVER_CONSULT'
        "
      >
        <i class="bi bi-info-circle me-2"></i>Per il Supporto caregiver non ci
        sono dettagli da compilare: la conversazione con la persona si trova nel
        tab Registro.
      </p>
      <!-- Request Operational Info -->
      <app-request-operational-info
        *ngIf="step === 2"
        [requestID]="request.id"
        [inputData]="request.operationalInfo"
        [requestCategory]="request.requestPersonalInfo.requestCategory"
        (dataUpdated)="updateRequestOperationalInfo($event)"
      ></app-request-operational-info>
      <!-- Request Selection Rounds -->
      <app-request-round
        [request]="request"
        [assignedNutritionist]="
          assignedNutritionist ? assignedNutritionist : null
        "
        [petsitterDetail]="petsitterDetail"
        [nurseDetail]="nurseDetail"
        [colfDetail]="colfDetail"
        *ngIf="step === 3"
      ></app-request-round>
      <!-- Request Messages -->
      <app-request-messages
        [requestID]="request.id"
        *ngIf="step === 4 && !isPartner"
      ></app-request-messages>
      <!-- Request Messages -->
      <app-request-partner-messages
        [requestID]="request.id"
        *ngIf="step === 4 && isPartner"
      ></app-request-partner-messages>
      <!-- Request Updates -->
      <app-request-updates
        *ngIf="step === 5"
        [requestID]="request.id"
      ></app-request-updates>
      <!-- nps -->
      <app-request-nps *ngIf="step === 6" [request]="request"></app-request-nps>
    </div>
  </div>
</div>

<app-alert
  *ngIf="showAlert"
  (save)="onSubmit($event)"
  [data]="{ type: undefined }"
  [title]="'Attenzione, alcuni dati sono stati modificati!'"
  [message]="'Vuoi salvare le modifiche effettuate?'"
>
</app-alert>
